import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

const styleComponent = (fontSize, color) => ({
  fontSize,
  color,
})

const SkIcon = ({ material, children, className, value, fontSize, color, ...other }) => {
  if (material) {
    return (
      <i className={cx('material-icons', className)} style={styleComponent(fontSize, color)} {...other}>
        {value}
      </i>
    )
  }
  return (
    <i className={cx('fa', `fa-${value}`, className)} style={styleComponent(fontSize, color)}>
      {children}
    </i>
  )
}

SkIcon.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  material: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  fontSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.string,
}

SkIcon.defaultProps = {
  className: '',
}

export default SkIcon



// WEBPACK FOOTER //
// ./src/components/Common/SkIcon/SkIcon.js